import React , {useState}from 'react';
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import Content1 from './components/Content1';
import Content2 from './components/Content2';

const { Header, Content, Footer } = Layout;

const items = [
  {
    key: '1',
    label: '加密&解密'
  },
  {
    key: '2',
    label: '其他'
  }
]

const Example: React.FC = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [currentPageKey, setCurrentPageKey] = useState<string>('1') 

  const handleSwitchMenu = (e: any) => {
    setCurrentPageKey(e.key)
  }

  const renderContent = () => {
    switch (currentPageKey) {
      case '1':
        return <Content1/>
        case '2':
          return <Content2/>
      default:
        return null
    }
  }

  return (
    <Layout>
      <Header style={{ display: 'flex', alignItems: 'center' }}>
        <div className="demo-logo" />
        <Menu
          theme="dark"
          mode="horizontal"
          // defaultSelectedKeys={['1']}
          selectedKeys={[currentPageKey]}
          items={items}
          style={{ flex: 1, minWidth: 0 }}
          onSelect={(e: any) => handleSwitchMenu(e)}
        />
      </Header>
      <Content style={{ margin: '24px 48px' }}>
        {
          renderContent()
        }
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        ©{new Date().getFullYear()}
      </Footer>
    </Layout>
  );
};

export default Example;
